import { useWeb3Auth } from "@web3auth/modal-react-hooks";
import { useCallback, useEffect } from "react";

export const Web3AuthOutsideClickCloser = () => {
  const { web3Auth } = useWeb3Auth();

  const addOutsideClickListener = useCallback(
    (modalElement: HTMLElement) => {
      const outsideClickHandler = (event: MouseEvent) => {
        if (!modalElement.contains(event.target as Node)) {
          console.log("Clicked outside Web3Auth modal. Closing...");
        }
      };
      document.addEventListener("mousedown", outsideClickHandler);
    },
    [web3Auth],
  );

  useEffect(() => {
    const checkAndSetContainer = () => {
      const target = document.querySelector(".w3a-modal__inner");

      if (target) {
        addOutsideClickListener(target as HTMLElement);
      }
    };

    checkAndSetContainer(); // check immediately on mount

    const observer = new MutationObserver(() => {
      checkAndSetContainer();
    });

    observer.observe(document.body as HTMLElement, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, [addOutsideClickListener]);

  return null;
};
